import { useTranslation } from "react-i18next";

import { Notice } from "@/components/Notice";
import { Button } from "@/components/ui/button";

export function AppVersionBanner() {
  const { t } = useTranslation();

  return (
    <section
      className="border-b border-warning-border bg-warning-bg px-4 py-2"
      aria-label={t("A new version is available")}
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3">
        <Notice tone="warning" toneLabel={t("Warning")} className="flex-1">
          {t("A new version is available")}
        </Notice>
        <Button type="button" size="sm" onClick={() => location.reload()}>
          {t("Reload")}
        </Button>
      </div>
    </section>
  );
}
